module.exports = __webpack_public_path__ + "fonts/materialdesignicons-webfont.0207b94.ttf";